import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class MessageService {
    private message = new Subject<any>();

    sendData<T>(message: T) {
        this.message.next(message);
    }

    clearData() {
        this.message.next();
    }

    getData<T>(): Observable<T> {
        return this.message.asObservable();
    }
}
